import {
  LegendColor,
  LegendText,
} from 'components/Charting/Legend/Legend.styled';
import { DynatraceTriggerAction } from 'components/DynatraceTriggerAction/dynatrace-trigger-action';
import { InfoCircleTooltip } from 'components/Tooltip/InfoCircleTooltip';
import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import {
  NegativeRevenueLabel,
  NegativeRevenueTooltip,
  RevenueBreakdownHint,
  RevenueBreakdownItem,
  RevenueBreakdownPrice,
  RevenueBreakdownRow,
  RevenueBreakdownTextWrapper,
  RevenueBreakdownWrapper,
} from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/RevenueBreakdownCard.styled';
import { RevenueBreakdownListProps } from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/RevenueBreakdownCard.types';
import {
  capitalizeSpecificFirstMarketWords,
  convertTitleCase,
} from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/utils';

const RevenueExpandedContent = ({
  colorMap,
  marketData,
  hint,
  hasNegativeRevenue,
}: RevenueBreakdownListProps) => {
  const sortedRevenueDescendingOrder = [...marketData].sort(
    (a, b) => b.revenue - a.revenue,
  );

  return (
    <RevenueBreakdownWrapper>
      {sortedRevenueDescendingOrder.map((market, index) => (
        <RevenueBreakdownRow key={index} data-testid={'revenue-breakdown-row'}>
          <RevenueBreakdownItem>
            <LegendColor style={{ backgroundColor: colorMap[market.market] }} />
            <LegendText>
              {capitalizeSpecificFirstMarketWords(
                convertTitleCase(market.market),
              )}
            </LegendText>
          </RevenueBreakdownItem>
          <RevenueBreakdownPrice>
            {market.revenue < 0 ? '- £' : '+ £'}
            {Math.abs(market.revenue).toLocaleString('en-GB', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </RevenueBreakdownPrice>
        </RevenueBreakdownRow>
      ))}
      <RevenueBreakdownTextWrapper>
        <RevenueBreakdownHint>{hint}</RevenueBreakdownHint>
        {hasNegativeRevenue ? (
          <NegativeRevenueTooltip>
            <NegativeRevenueLabel>
              Why could I have negative revenue?
            </NegativeRevenueLabel>
            <InfoCircleTooltip
              tooltip={
                <>
                  When you charge your battery site, you consume energy from the
                  grid. This energy is bought from the open market, resulting in
                  negative revenue. You then discharge and sell your energy at a
                  later stage.
                  <DynatraceTriggerAction
                    action={DYNATRACE_ACTIONS.TOOLTIP_NEGATIVE_REVENUE}
                  />
                </>
              }
            />
          </NegativeRevenueTooltip>
        ) : null}
      </RevenueBreakdownTextWrapper>
    </RevenueBreakdownWrapper>
  );
};

export default RevenueExpandedContent;
